import { useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { useSchedulingRuleTable } from 'hooks/schedulingRules/useSchedulingRuleTable';
import { ContextMenu } from './ContextMenu';

const getSchedulingRuleRowId = (row: any) => row.id ?? row.ruleset_id;

const SchedulingRuleTable = () => {
    const { t } = useTranslation();
    const { rows, loading, columns, reloading, contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected } = useSchedulingRuleTable();

    useEffect(() => {
        reloading();
    }, [reloading]);

    return (
        <div
            style={{ width: '100%', height: '100%' }}
            onContextMenu={(event) => {
                event.preventDefault();
                setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
            }}
        >
            <DataGridPro
                sx={{ height: 'calc(100vh - 140px)' }}
                columns={columns}
                rows={rows}
                getRowId={getSchedulingRuleRowId}
                showCellVerticalBorder
                showColumnVerticalBorder
                headerFilters
                localeText={{
                    headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                    headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                    headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                    headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                    headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                    headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                    footerRowSelected: (count) =>
                        count > 1
                            ? `${t('general.table.footerFilters.footerRowSelected.>1', { count, countFormatted: count.toLocaleString() })} `
                            : `${t('general.table.footerFilters.footerRowSelected.=1', { count, countFormatted: count.toLocaleString() })}`,
                }}
                disableColumnMenu
                loading={loading}
                checkboxSelection
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    const row = rows.filter((r) => newRowSelectionModel.includes(getSchedulingRuleRowId(r)));
                    setSelected(newRowSelectionModel);
                    setSelectedRow(row);
                }}
                rowSelectionModel={selected}
                pagination
            />

            <ContextMenu contextMenu={contextMenu} setContextMenu={setContextMenu} selectedRow={selectedRow} reloading={reloading} rows={rows} cleanSelected={cleanSelected} />
        </div>
    );
};

export { SchedulingRuleTable };
